export default __webpack_public_path__ + "static/media/Rodolfo3.28a5a695.png";